import { FormControl } from '@angular/forms';
export class UsernameValidator {
  static validUsername(fc: FormControl){
      var pattern = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!~._()`[\]-])[A-Za-z\d!~._()`[\]-]*$/g;
      if (pattern.test(fc.value)) {
        return (null)
    } else {
       return ({validUsername: true});
    }   

  }
}